import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';

const Component = lazy(() => import('components/two-factor-confirm-button'));

const TwoFactorConfirmButton = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={null}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default TwoFactorConfirmButton;
